// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"e2d055dd","503":"741f536c","710":"109e9f15","911":"25cc388d"}[chunkId] + ".chunk.js";
};